// Thông tin thương hiệu phần mềm — đổi tại đây sẽ áp dụng toàn hệ thống
export const APP_NAME = 'Quản Lý Cầm Đồ';
export const APP_TAGLINE = 'Hệ thống quản lý cầm đồ';
export const APP_FOOTER = `© ${new Date().getFullYear()} ${APP_NAME}`;
export const APP_LOGO_ICON = 'ri-safe-2-line';
// Liên hệ gia hạn thuê bao — đổi thành SĐT/Zalo của người bán khi phát hành
export const SUPPORT_CONTACT = '';
export const DEFAULT_CATEGORIES = ['Vàng bạc', 'Điện tử', 'Điện thoại', 'Xe máy', 'Ô tô', 'Đồ gia dụng', 'Khác'];
export const DEFAULT_WAREHOUSES = ['Kho 1', 'Kho 2', 'Kho 3'];

export function shopCategories(shop: { loanCategories?: string[] } | null | undefined): string[] {
  return shop?.loanCategories?.length ? shop.loanCategories : DEFAULT_CATEGORIES;
}

export function shopWarehouses(shop: { warehouses?: string[] } | null | undefined): string[] {
  return shop?.warehouses?.length ? shop.warehouses : DEFAULT_WAREHOUSES;
}
